import { Component, computed, effect, inject, input, output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';
import { FormOption, FormSelectComponent } from '@shared/forms';
import { PrintersFacade } from '@app/store/printers';
import { ButtonComponent } from '../button/button.component';
import { ClIcon } from '@corelabs/angular/ui';
import { Send } from 'lucide';

/* Printer picker + send button for the view modals; requires `providePrintersStore()` on the route. */
@Component({
    selector: 'app-print-target',
    templateUrl: './print-target.component.html',
    styleUrls: ['./print-target.component.css'],

    host: { '[class.empty]': '!options().length' },
    imports: [TranslatePipe, FormSelectComponent, ButtonComponent, ClIcon],
})
export class PrintTargetComponent {
    protected readonly icons = { Send };

    readonly control = input.required<FormControl<string>>();
    readonly submitLabel = input.required<string>();
    /** Printer to select first, when the entity has one of its own (a station's printer). */
    readonly prefer = input<string>();
    readonly busy = input(false);

    readonly print = output<void>();

    private readonly printersFacade = inject(PrintersFacade);

    readonly options = computed<FormOption<string>[]>(() =>
        this.printersFacade.enabledPrinters().map((printer) => ({ label: printer.name, value: printer.id })),
    );

    constructor() {
        if (this.printersFacade.loaded() !== true) {
            this.printersFacade.getPrinters();
        }

        // Pre-select the entity's own printer, else the admin default, else the first available.
        effect(() => {
            const printers = this.printersFacade.enabledPrinters();
            const control = this.control();
            if (!printers.length || control.value) {
                return;
            }
            const preferred = this.prefer();
            const target = printers.find((printer) => printer.id === preferred) ?? printers.find((printer) => printer.isAdminDefault) ?? printers[0];
            control.setValue(target.id);
        });
    }
}
